import { FC, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { MY_PLAN_PATH } from "./planLimits";
import { RESOURCE_LABELS, resourcesAtWarning, usePlanUsage } from "./planUsage";

// Aviso antecipado aos 90% de qualquer limite do plano (AAC-68 D4, AAC-81). Fica no layout e some
// na própria tela "Meu plano". Falha na rota de uso não mostra nada.
export const PlanLimitBanner: FC = () => {
  const { pathname } = useLocation();
  const { usage, error } = usePlanUsage({ refreshKey: pathname });

  if (error || !usage || pathname === MY_PLAN_PATH) return null;

  if (usage.reason === "no_active_contract") {
    return (
      <div
        className="alert alert-danger d-flex align-items-center mb-5"
        role="alert"
        data-testid="plan-limit-banner"
      >
        Seu clube não tem contrato ativo. Fale com a AACCESON.
      </div>
    );
  }

  const avisos = resourcesAtWarning(usage);
  if (avisos.length === 0) return null;

  return (
    <div
      className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-3 mb-5"
      role="alert"
      data-testid="plan-limit-banner"
    >
      <div>
        {avisos.map(({ resource, usage: u }, index) => (
          <Fragment key={resource}>
            {index > 0 && " · "}
            <span>
              Você usou {u.percent}% do limite de {RESOURCE_LABELS[resource]} do
              seu plano ({u.used}/{u.limit}).
            </span>
          </Fragment>
        ))}
      </div>
      <Link to={MY_PLAN_PATH} className="btn btn-sm btn-light-warning">
        Ver planos
      </Link>
    </div>
  );
};
